export const TWENTY_MINUTES_IN_SECONDS = 20 * 60;
export const HOUR_IN_SECONDS = 60 * 60;
export const TWENTY_HOURS_IN_SECONDS = 20 * 60 * 60;
export const DAY_IN_SECONDS = 24 * 60 * 60;
export const MINUTE_IN_MILLISECONDS = 1000 * 60;
export const FIVE_MINUTES_IN_SECONDS = 60 * 5;
